<rid-klankvoeten-recognize
  class="h-dvh"
  [assignments]="[
    {
      word: 'tijger',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
      rule: 'SPLIT_BEFORE_CENTRAL_CONSONANT',
    },
    {
      word: 'leeuw',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
      rule: 'SPLIT_AFTER_MULTITEKEN_KLANK',
    },
    {
      word: 'olifant',
      audio: { pronounce: 'olifant' },
      rule: 'SPLIT_BEFORE_CENTRAL_CONSONANT',
    },
    {
      word: 'panda',
      audio: { pronounce: 'panda' },
      rule: 'SPLIT_BETWEEN_CONSONANTS',
    },
  ]"
  (finished)="router.navigate(['mechanics/phonetic-comprehension'])"
/>
